import { Box, Typography } from "@material-ui/core";
import { Stack, styled } from "@mui/material";
import React from "react";
import { primary } from "../../constants/theme";
import { MemoizedButton } from "../../SDK/button";
import { myScroll } from "../../utils/myScroll";

const CustomBrandBanner = styled(Box)(({ theme }) => ({
  height: "650px",
  padding: "40px",
  background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 130%), url(${process.env.NEXT_PUBLIC_CDN_LINK}Retail+Page/webp/banner_desktop.webp)`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100vw",
  //backgroundSize:"100%",
  paddingTop: "360px",

  ".headerInfo": {
    fontSize: "28px",
    lineHeight: "42px",
    fontWeight: "900",
    color: primary.white,
    // display:"flex",
    // justifyContent:"center",
    background:
      "linear-gradient(90deg, rgba(232, 52, 94, 0.18) 0%, rgba(232, 52, 94, 0.9) 52.21%, rgba(232, 52, 94, 0.21) 104.83%)",
    padding: "8px",
    marginLeft: "20px",
    marginRight: "20px",
    maxWidth: "600px",
    textAlign: "center",
    // textTransform:'capitalize',
    ".electric": {
      color: primary.main,
    },
  },
  ".heading-about-turno": {
    fontSize: "40px",
    lineHeight: "64px",
    textAlign: "center",
    color: primary.white,
    // textTransform: "capitalize",
    span: {
      color: primary.electricGreen, //"#00EE98",
    },
  },

  ".visitStoreCta": {
    borderRadius: "8px",
    background: primary.white,
    color: primary.mainText,
    boxShadow: "none",
    margin: "10px 40px 10px 40px",
    padding: "8px",
    width: "300px",
    "&:hover": {
      color: primary.main,
      background: primary.white,
    },
  },
  [theme.breakpoints.down("md")]: {
    height: "500px",
    background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 130%), url(${process.env.NEXT_PUBLIC_CDN_LINK}Retail+Page/webp/banner.webp)`,
    paddingTop: "260px",
    backgroundSize: "100%",
    ".headerInfo": {
      fontSize: "20px",
      lineHeight: "27px",
      //marginBottom: "12px",
    },
    ".heading-about-turno": {
      fontSize: "20px",
      lineHeight: "35px",
      margin: "8px 0px 8px 0px",
    },

    ".visitStoreCta": {
      width: "200px",
    },
  },
}));

const BrandBanner = () => {
  return (
    <CustomBrandBanner>
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Stack
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
          }}
        >
          <Typography variant="h1" className="headerInfo">
            Turno Multi-brand Store
          </Typography>
        </Stack>
        <Typography className="heading-about-turno">
          Experience Electric Gadi's from the best brands 
        </Typography>

        <Stack
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
          }}
        >
          <MemoizedButton
            className="visitStoreCta"
            idlocal={`visitStore`}
            content={`Get Visit Pass`}
            handleClick={() => {
              myScroll(
                0,
                document.getElementById("book-ticket").offsetTop - 100,
                "smooth"
              );
            }}
          />
        </Stack>
      </Box>
    </CustomBrandBanner>
  );
};
export default BrandBanner;
